import { BaseProtoLinksDto } from '../../shared/dtos/base-proto-links.dto';

/**
 * Asset reservation links DTO
 */
export class AssetReservationLinksDto extends BaseProtoLinksDto {}
